import * as Types from '../../../graphql/generated/types';

import { gql } from '@apollo/client';
import { PersonListDataFragmentDoc } from '../list/list.generated';
import * as Apollo from '@apollo/client';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type DeletePersonMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;

export type DeletePersonMutation = {
  __typename?: 'Mutation';
  adminDeletePerson: boolean;
};

export type AnonymizePersonMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;

export type AnonymizePersonMutation = {
  __typename?: 'Mutation';
  adminAnonymizePerson: {
    __typename?: 'Person';
    id: any;
    firstName?: string | null;
    lastName?: string | null;
    anonymizedAt?: any | null;
    user?:
      | {
          __typename: 'Administrator';
          roleIds?: Array<any> | null;
          isBot: boolean;
          id: any;
          username?: string | null;
          status: Types.UserStatus;
          roles: Array<{ __typename?: 'Role'; id: any; name: Types.RoleType }>;
        }
      | {
          __typename: 'Customer';
          customerNumber?: string | null;
          id: any;
          username?: string | null;
          status: Types.UserStatus;
        }
      | {
          __typename: 'Teacher';
          id: any;
          username?: string | null;
          status: Types.UserStatus;
        }
      | null;
    enterprises: Array<{ __typename?: 'Enterprise'; id: any; name: string }>;
    contactProperties: Array<{
      __typename?: 'ContactProperty';
      key: Types.ContactPropertyKey;
      value: string;
    }>;
  };
};

export type CheckForDuplicatesMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CheckForDuplicatesMutation = {
  __typename?: 'Mutation';
  checkForDuplicates: boolean;
};

export type LinkDuplicatesMutationVariables = Types.Exact<{
  person1Id: Types.Scalars['UUID'];
  person2Id: Types.Scalars['UUID'];
}>;

export type LinkDuplicatesMutation = {
  __typename?: 'Mutation';
  adminLinkDuplicates: boolean;
};

export const DeletePersonDocument = gql`
  mutation deletePerson($id: UUID!) {
    adminDeletePerson(id: $id)
  }
`;
export type DeletePersonMutationFn = Apollo.MutationFunction<
  DeletePersonMutation,
  DeletePersonMutationVariables
>;
export type DeletePersonComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeletePersonMutation,
    DeletePersonMutationVariables
  >,
  'mutation'
>;

export const DeletePersonComponent = (props: DeletePersonComponentProps) => (
  <ApolloReactComponents.Mutation<
    DeletePersonMutation,
    DeletePersonMutationVariables
  >
    mutation={DeletePersonDocument}
    {...props}
  />
);

/**
 * __useDeletePersonMutation__
 *
 * To run a mutation, you first call `useDeletePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonMutation, { data, loading, error }] = useDeletePersonMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePersonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePersonMutation,
    DeletePersonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeletePersonMutation,
    DeletePersonMutationVariables
  >(DeletePersonDocument, options);
}
export type DeletePersonMutationHookResult = ReturnType<
  typeof useDeletePersonMutation
>;
export type DeletePersonMutationResult =
  Apollo.MutationResult<DeletePersonMutation>;
export type DeletePersonMutationOptions = Apollo.BaseMutationOptions<
  DeletePersonMutation,
  DeletePersonMutationVariables
>;
export const AnonymizePersonDocument = gql`
  mutation anonymizePerson($id: UUID!) {
    adminAnonymizePerson(id: $id) {
      ...PersonListData
    }
  }
  ${PersonListDataFragmentDoc}
`;
export type AnonymizePersonMutationFn = Apollo.MutationFunction<
  AnonymizePersonMutation,
  AnonymizePersonMutationVariables
>;
export type AnonymizePersonComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AnonymizePersonMutation,
    AnonymizePersonMutationVariables
  >,
  'mutation'
>;

export const AnonymizePersonComponent = (
  props: AnonymizePersonComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    AnonymizePersonMutation,
    AnonymizePersonMutationVariables
  >
    mutation={AnonymizePersonDocument}
    {...props}
  />
);

/**
 * __useAnonymizePersonMutation__
 *
 * To run a mutation, you first call `useAnonymizePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnonymizePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [anonymizePersonMutation, { data, loading, error }] = useAnonymizePersonMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnonymizePersonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AnonymizePersonMutation,
    AnonymizePersonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AnonymizePersonMutation,
    AnonymizePersonMutationVariables
  >(AnonymizePersonDocument, options);
}
export type AnonymizePersonMutationHookResult = ReturnType<
  typeof useAnonymizePersonMutation
>;
export type AnonymizePersonMutationResult =
  Apollo.MutationResult<AnonymizePersonMutation>;
export type AnonymizePersonMutationOptions = Apollo.BaseMutationOptions<
  AnonymizePersonMutation,
  AnonymizePersonMutationVariables
>;
export const CheckForDuplicatesDocument = gql`
  mutation checkForDuplicates {
    checkForDuplicates
  }
`;
export type CheckForDuplicatesMutationFn = Apollo.MutationFunction<
  CheckForDuplicatesMutation,
  CheckForDuplicatesMutationVariables
>;
export type CheckForDuplicatesComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CheckForDuplicatesMutation,
    CheckForDuplicatesMutationVariables
  >,
  'mutation'
>;

export const CheckForDuplicatesComponent = (
  props: CheckForDuplicatesComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    CheckForDuplicatesMutation,
    CheckForDuplicatesMutationVariables
  >
    mutation={CheckForDuplicatesDocument}
    {...props}
  />
);

/**
 * __useCheckForDuplicatesMutation__
 *
 * To run a mutation, you first call `useCheckForDuplicatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckForDuplicatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkForDuplicatesMutation, { data, loading, error }] = useCheckForDuplicatesMutation({
 *   variables: {
 *   },
 * });
 */
export function useCheckForDuplicatesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CheckForDuplicatesMutation,
    CheckForDuplicatesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CheckForDuplicatesMutation,
    CheckForDuplicatesMutationVariables
  >(CheckForDuplicatesDocument, options);
}
export type CheckForDuplicatesMutationHookResult = ReturnType<
  typeof useCheckForDuplicatesMutation
>;
export type CheckForDuplicatesMutationResult =
  Apollo.MutationResult<CheckForDuplicatesMutation>;
export type CheckForDuplicatesMutationOptions = Apollo.BaseMutationOptions<
  CheckForDuplicatesMutation,
  CheckForDuplicatesMutationVariables
>;
export const LinkDuplicatesDocument = gql`
  mutation linkDuplicates($person1Id: UUID!, $person2Id: UUID!) {
    adminLinkDuplicates(person1Id: $person1Id, person2Id: $person2Id)
  }
`;
export type LinkDuplicatesMutationFn = Apollo.MutationFunction<
  LinkDuplicatesMutation,
  LinkDuplicatesMutationVariables
>;
export type LinkDuplicatesComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    LinkDuplicatesMutation,
    LinkDuplicatesMutationVariables
  >,
  'mutation'
>;

export const LinkDuplicatesComponent = (
  props: LinkDuplicatesComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    LinkDuplicatesMutation,
    LinkDuplicatesMutationVariables
  >
    mutation={LinkDuplicatesDocument}
    {...props}
  />
);

/**
 * __useLinkDuplicatesMutation__
 *
 * To run a mutation, you first call `useLinkDuplicatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkDuplicatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkDuplicatesMutation, { data, loading, error }] = useLinkDuplicatesMutation({
 *   variables: {
 *      person1Id: // value for 'person1Id'
 *      person2Id: // value for 'person2Id'
 *   },
 * });
 */
export function useLinkDuplicatesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LinkDuplicatesMutation,
    LinkDuplicatesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    LinkDuplicatesMutation,
    LinkDuplicatesMutationVariables
  >(LinkDuplicatesDocument, options);
}
export type LinkDuplicatesMutationHookResult = ReturnType<
  typeof useLinkDuplicatesMutation
>;
export type LinkDuplicatesMutationResult =
  Apollo.MutationResult<LinkDuplicatesMutation>;
export type LinkDuplicatesMutationOptions = Apollo.BaseMutationOptions<
  LinkDuplicatesMutation,
  LinkDuplicatesMutationVariables
>;
